<div class="dropdown-wrapper">
  <app-dropdown
    [dropdownGroupedItems]="documentActions"
    [triggerIcon]="triggerIcon"
    [showChevron]="false"
    [disabled]="!document"
    [horizontalAlignment]="dropdownHorizontalAlignment"
  >
    <ng-template
      let-closeCallback="closeCallback"
      let-documentAction="dropdownItem"
    >
      <ng-container [ngSwitch]="documentAction">
        <button
          *ngSwitchCase="DocumentActionsEnum.approve_document"
          type="button"
          class="document-action approve-action"
          trackable
          [trackingObject]="trackingObject"
          [trackingAction]="approveAction"
          (click)="approveDocument(); closeCallback()"
        >
          {{ 'ACTION.APPROVE' | translate }}
        </button>

        <button
          *ngSwitchCase="DocumentActionsEnum.decline_document"
          type="button"
          class="document-action decline-action"
          trackable
          [trackingObject]="trackingObject"
          [trackingAction]="declineAction"
          (click)="declineDocument(); closeCallback()"
        >
          {{ 'ACTION.DECLINE' | translate }}
        </button>

        <app-copy-document-action
          *ngSwitchCase="DocumentActionsEnum.copy_document"
          trackable
          [trackingObject]="trackingObject"
          [trackingAction]="copyAction"
          (onOpenCopyDocumentDialog)="openCopyDocumentDialog(); closeCallback()"
        >
        </app-copy-document-action>

        <app-convert-to-invoice-action
          *ngSwitchCase="DocumentActionsEnum.convert_document_to_invoice"
          [featureToggles]="featureToggles"
          [documentFeatureName]="featureName"
          [disableConvertAction]="disableConvertAction"
          trackable
          [trackingObject]="trackingObject"
          [trackingAction]="convertAction"
          (onConvertToInvoice)="onConvertToInvoice(); closeCallback()"
        >
        </app-convert-to-invoice-action>

        <app-print-document-action
          *ngSwitchCase="DocumentActionsEnum.print_document"
          [document]="document"
          [paymentSettings]="settings.payments"
          [featureName]="featureName"
          [featureToggles]="featureToggles"
          trackable
          [trackingObject]="trackingObject"
          [trackingAction]="printAction"
          (onPrintDocument)="printDocument(); closeCallback()"
        >
        </app-print-document-action>

        <app-export-xero-action
          *ngSwitchCase="DocumentActionsEnum.export_document_to_xero"
          [document]="document"
          [toggles]="featureToggles"
          [xeroAccount]="xeroAccount"
          trackable
          [trackingObject]="trackingObject"
          [trackingAction]="exportAction"
          (onExportXero)="closeCallback()"
        >
        </app-export-xero-action>
      </ng-container>
    </ng-template>
  </app-dropdown>
</div>

<button
  i2gButton
  buttonStyle="emphasis"
  type="button"
  [disabled]="!document || savingDocument"
  class="primary-action"
  data-e2e-id="document-save-action"
  trackable
  [trackingObject]="trackingObject"
  [trackingAction]="saveAction"
  (click)="saveDocument()"
>
  {{ 'ACTION.SAVE_AND_CLOSE' | translate }}
</button>

<app-copy-document-dialog
  *ngIf="document"
  [trackingScreenName]="trackingScreenName"
  [document]="document"
  [taxes]="taxes"
  [disableDocumentTypes]="disableCopyDocumentTypes"
  (onCopyDocument)="onCopyDocument($event)"
>
</app-copy-document-dialog>

<app-convert-to-invoice-dialog
  [document]="document"
  [trackingScreenName]="trackingScreenName"
  (onConvert)="convertToInvoice()"
>
</app-convert-to-invoice-dialog>
